import { FC } from "react";
import { Button, ConfigProvider, Modal } from "antd";

import styles from "./index.less";

import { ReactComponent as PaySuccessIcon } from "../../assets/svg/pay-success.svg";

import { PrimaryTheme } from "@packages/theme";

interface PlanPayWithBankTransferSuccessModalProps {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
}

const PlanPayWithBankTransferSuccessModal: FC<
  PlanPayWithBankTransferSuccessModalProps
> = ({ open, onClose, onOk }) => {
  return (
    <ConfigProvider theme={PrimaryTheme}>
      <Modal
        centered
        open={open}
        width={560}
        footer={null}
        maskClosable={false}
        onCancel={onClose}
        onClose={onClose}
        classNames={{
          content: styles["modal-content"],
        }}
      >
        <div className={styles.container}>
          <PaySuccessIcon />
          <div className={styles.title}>转账确认已提交</div>
          <div className={styles.description}>
            我们已收到您的确认请求，财务部门将尽快为您完成审批流程，请耐心等候
          </div>
          <div className={styles["btn-group"]}>
            <Button type="primary" onClick={onOk}>
              我知道了
            </Button>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default PlanPayWithBankTransferSuccessModal;
